import React, { useState, useEffect } from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import MenuIcon from "@mui/icons-material/Menu";
import AddIcon from "@mui/icons-material/Add";
import {
  OverlayTrigger,
  Popover,
  Overlay,
  Modal,
  Toast,
  NavLink,
} from "react-bootstrap";
import dayjs from "dayjs";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { v4 as uuidv4 } from "uuid";

import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteIcon from "@mui/icons-material/Delete";
import EmailRules from "./editForm/EmailRules";
function Settings({
  serverURL,
  user,
  setShowSideOverlay,
  socket,
  logToUse,
  setLogToUse,
}) {
  const GOOGLE_CLIENT_ID =
    "244629792859-kham99pti736hrc9qi7g4tsr5382vfk3.apps.googleusercontent.com"; // Replace with your actual Client ID
  const [emailAccounts, setEmailAccounts] = useState([]);

  const [dataToUse, setDataToUse] = useState(null);
  const [askDelete, setAskDelete] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState(null);
  const [toastTitle, setToastTitle] = useState(null);
  const [toastMessage, setToastMessage] = useState(null);
  const [page, setPage] = useState("emailAccount");
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 37,
    height: 21,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#65C466",
          opacity: 1,
          border: 0,
          ...theme.applyStyles("dark", {
            backgroundColor: "#2ECA45",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 17,
      height: 17,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));

  const getAllAccounts = async () => {
    const getEmailAccountsNow = await axios.post(
      serverURL + "/emailAccounts/getEmailAccounts"
    );
    if (getEmailAccountsNow.status === 200) {
      console.log(getEmailAccountsNow.data);
      setEmailAccounts(getEmailAccountsNow.data);
    } else {
      setShowToast(true);
      setToastType("success");
      setToastTitle("Success");
      setToastMessage("Fetched All Accounts!");
    }
  };

  const changeActiveStatus = async (uid) => {
    const query = {
      uid: uid,
    };
    const updateUserStatus = await axios.post(
      serverURL + "/emailAccounts/editEmailAccount",
      query
    );
    if (updateUserStatus.status !== 200) {
      setShowToast(true);
      setToastType("error");
      setToastTitle("Error");
      setToastMessage(updateUserStatus.data);
    } else {
      // setShowToast(true)
      // setToastType("success")
      // setToastTitle("Success")
      // setToastMessage("Status changed successfully!")
      // getAllAccounts()
    }
  };

  const deleteThisAccount = async (uid) => {
    if (uid) {
      const deleteEmailAccount = await axios.post(
        serverURL + "/emailAccounts/deleteEmailAccount",
        { uid: uid }
      );
      if (deleteEmailAccount.status === 200) {
        console.log(deleteEmailAccount.data);
        const newAccounts = emailAccounts.filter((acc) => {
          return acc.uid !== uid;
        });
        setEmailAccounts(newAccounts);
        setAskDelete(false);

        setShowToast(true);
        setToastType("success");
        setToastTitle("Success");
        setToastMessage("Accound deleted successfully!");
      } else {
        setShowToast(true);
        setToastType("error");
        setToastTitle("Error");
        setToastMessage(deleteEmailAccount.data);
      }
    } else {
      console.log("id not provided");
    }
  };

  useEffect(() => {
    getAllAccounts();
  }, []);

  const Login = () => {
    const login = useGoogleLogin({
      onSuccess: async (response) => {
        console.log("Authorization Code:", response.code);
        try {
          const query = { code: response.code, uid: uuidv4() };
          const addAccount = await axios.post(
            serverURL + "/emailAccounts/addEmailAccount",
            query
          );
          if (addAccount.status === 200) {
            console.log(addAccount.data);
            setEmailAccounts([...emailAccounts, addAccount.data]);

            setShowToast(true);
            setToastType("success");
            setToastTitle("Success");
            setToastMessage("Account added successfully!");
          } else {
            setShowToast(true);
            setToastType("error");
            setToastTitle("Error");
            setToastMessage(addAccount.data);
          }
        } catch (error) {
          console.error("Login Error:", error);
        }
      },
      flow: "auth-code",
      access_type: "offline",
      prompt: "consent",
      scope: "openid email profile https://mail.google.com/ https://www.googleapis.com/auth/calendar.events",
      redirect_uri: "http://localhost:3000",
    });

    return (
      <button
        className="btn btn-sm rounded-3 btn-light shadow-sm border d-flex gap-2 p-3 align-items-center"
        onClick={() => login()}
      >
        <AddIcon style={{ fontSize: "1.5rem" }} className="text-secondary" />
      </button>
    );
  };

  const logOut = async () => {
    document.cookie =
      "userTos=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "tokenTos=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    const logOut = await axios.get(serverURL + "/deleteCookie/" + user.email, {
      withCredentials: true,
    });
    if (logOut) {
      window.location.href = "/";
    }
  };

  return (
    <>
      <div className="transback h-100 d-flex flex-column p-3">
        <button
          className="btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2"
          onClick={() => {
            setShowSideOverlay(true);
          }}
        >
          <MenuIcon />
        </button>
        <div className="headerUserDetails py-1 border-0 d-flex justify-content-between">
          <span>Settings</span>
          <div
            className="d-flex gap-2 align-items-center justify-content-center text-dark px-2"
            style={{ cursor: "pointer" }}
            title={"Name: " + user.name + "\nEmail: " + user.email}
          >
            <i className="fa fa-user"></i>
            <span>{user.name}</span>
          </div>
        </div>
        <div className={`w-100 h-100 overflow-auto gap-2 p-3`}>
          <div className="row">
            <div className="col-2">
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink onClick={() => setPage("emailAccount")} className="nav-link cursor-pointer">
                    Email Accuonts
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink onClick={() => setPage("emailRule")} className="nav-link cursor-pointer">
                    Set Email Rules
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="col">
                { page === "emailAccount" ? 
                <div className="">
                <p
                  className="p-0 display-6"
                  style={{ fontSize: "1.6rem", fontWeight: "400" }}
                >
                  Connected Email Accounts
                </p>
                <table className="table table-bordered table-hover">
                  <thead className="table-success">
                    <tr align="center">
                      <th>#{emailAccounts?.length}</th>
                      <th></th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Created</th>
                      <th>Last Update</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {emailAccounts.length > 0 ? (
                      emailAccounts.map((account, key) => {
                        return (
                          <tr key={key} align="center">
                            <td valign="middle">{key + 1}</td>
                            <td valign="middle" className="text-nowrap">
                              <img
                                src={account.picture}
                                alt=""
                                className="rounded-circle bg-dark"
                                style={{
                                  aspectRatio: "1/1",
                                  width: "50px",
                                  objectFit: "contain",
                                }}
                              />{" "}
                            </td>
                            <td valign="middle" className="text-nowrap">
                              {account.name}
                            </td>
                            <td valign="middle" className="text-nowrap">
                              {account.email}
                            </td>
                            <td valign="middle" className="text-nowrap">
                              {dayjs(account.createdAt).format(
                                "dddd, DD MMMM YYYY, h:mma"
                              )}
                            </td>
                            <td valign="middle" className="text-nowrap">
                              {dayjs(account.updatedAt).format(
                                "dddd, DD MMMM YYYY, h:mma"
                              )}
                            </td>
                            <td valign="middle" className="text-nowrap">
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    sx={{ m: 1 }}
                                    defaultChecked={
                                      account.status ? true : false
                                    }
                                  />
                                }
                                onChange={() => {
                                  changeActiveStatus(account.uid);
                                }}
                                label={null}
                              />
                            </td>
                            <td valign="middle">
                              <DeleteIcon
                                className="text-danger"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setAskDelete(true);
                                  setDataToUse(account);
                                }}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr align="center">
                        <td valign="middle" colSpan={9}>
                          No account assigned yet
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                  <Login />
                </GoogleOAuthProvider>
              </div> : null }

              {page === "emailRule" ? ( <EmailRules />) : null}
              
            </div>
          </div>
        </div>
      </div>

      {/* ############################### Ask Delete Panel ############################# */}
      <Modal
        show={askDelete}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        onHide={() => {
          setAskDelete(false);
        }}
      >
        <Modal.Header className="py-2" closeButton closeVariant="black">
          <Modal.Title id="contained-modal-title-vcenter">
            <span style={{ fontSize: "1.1rem" }}>Conformation Required</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <p className="alert alert-danger shadow-sm m-0 fs-5 border-0 py-5 text-center rounded-0">
            Do you really want to Delete <b>{dataToUse?.name}'s</b> Calendar?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center justify-content-center gap-4 w-100">
            <button
              className="btn btn-md btn-outline-secondary w-100 rounded-pill"
              style={{ maxWidth: "130px" }}
              onClick={() => {
                setAskDelete(false);
                setDataToUse(null);
              }}
            >
              No Cancel
            </button>
            {
              <button
                className="btn btn-md btn-danger w-100 rounded-pill"
                style={{ maxWidth: "130px" }}
                onClick={() => {
                  deleteThisAccount(dataToUse.uid);
                }}
              >
                Yes Delete
              </button>
            }
          </div>
        </Modal.Footer>
      </Modal>
      {/* ############################### Ask Delete Panel End ############################# */}

      {/* ############################### Notification Panel Start ############################# */}
      {showToast && (
        <div style={{ position: "fixed", bottom: "5px", right: "5px" }}>
          <Toast
            show={showToast}
            position="bottom-end"
            onClose={() => {
              setShowToast(false);
              setToastType(null);
              setToastTitle(null);
              setToastMessage(null);
            }}
            delay={2000}
            autohide
            // bg={toastType === "error" ? "danger" : toastType === "warning" ? "warning" : toastType === "info" ? "info" : toastType === "success" ? "success" : "success"}
          >
            <Toast.Header>
              <img
                src="holder.js/20x20?text=%20"
                className="rounded me-2"
                alt=""
              />
              <strong className="me-auto">{toastTitle}</strong>
              <small>Just Now</small>
            </Toast.Header>
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      )}
      {/* ############################### Notification Panel End ############################# */}
    </>
  );
}

export default Settings;
